// extracted by mini-css-extract-plugin
module.exports = {"error":"errormessage_error__Zs07X","icon":"errormessage_icon__2bgCU"};